<template>
    <div class="d-flex justify-content-between mx-0 row">
        <div class="col-sm-6 col-md-3 px-0">
            <form-select
                class="px-0"
                v-model="pageSize"
                @change="currentPage = 1"
                :itens="perPage"
            />
        </div>
        <div class="col-sm-6 col-md-auto pt-1 text-center">
            {{ currentLengthResult }} de {{ total }} resultados
        </div>
        <div class="col-sm-12 col-md-auto px-0 d-flex justify-content-end">
            <ul class="pagination" v-if="numPage > 1">
                <li class="paginate_button page-item previous disabled">
                    <a href="#" class="page-link" @click="prevPage"
                        ><i class="mdi mdi-chevron-left"></i
                    ></a>
                </li>
                <li class="page-item" v-if="numPage > 12 && currentPage != 1">
                    <a class="page-link" href="#" @click="currentPage = 1"
                        >1...</a
                    >
                </li>

                <li
                    :class="`page-item ${i + 1 == currentPage ? 'active' : ''}`"
                    @click="pageCurrent(i + 1)"
                    v-for="(page, i) in numDataPerPage"
                    :key="i"
                >
                    <a
                        class="page-link"
                        href="#"
                        v-if="
                            currentPage > 0 &&
                            i + 1 >= currentPage - 1 &&
                            i + 1 < currentPage + 5
                        "
                        >{{ i + 1 }}</a
                    >
                </li>
                <li
                    class="paginate_button page-item"
                    v-if="numPage > 5 && numPage != currentPage"
                >
                    <a class="page-link" href="#" @click="currentPage = numPage"
                        >...{{ numPage }}</a
                    >
                </li>
                <li class="paginate_button page-item next">
                    <a href="#" @click="nextPage" class="page-link">
                        <i class="mdi mdi-chevron-right"></i>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    props: ["total", "current"],
    data() {
        return {
            currentPage: this.current,
            currentLengthResult: 0,
            pageSize: 10,
            numPage: 0,
            perPage: [
                { id: 7, value: "7 Por página" },
                { id: 10, value: "10 Por página" },
                { id: 25, value: "25 Por página" },
                { id: 50, value: "50 Por página" },
                { id: 75, value: "75 Por página" },
                { id: 100, value: "100 Por página" },
            ],
        };
    },
    watch: {
        currentPage(value) {
            if (isNaN(value)) {
                this.currentPage = 1;
            }
            this.limitPage(value);
        },
    },
    mounted() {
        this.getCalc();
    },
    updated() {
        this.getCalc();
    },
    computed: {
        numDataPerPage() {
            this.getResultPage();
            return this.calcNumeroPage();
        },
    },
    methods: {
        limitPage(valor) {
            if (valor == this.numPage) {
                this.$emit("load", valor, this.pageSize);
            } else {
                if ((valor * this.pageSize) % 1000 == 0) {
                    this.$emit("load", this.currentPage, this.pageSize);
                }
            }
        },
        getCalc() {
            this.calcNumeroPage();
            this.getResultPage();
        },
        calcNumeroPage() {
            var num = this.total / this.pageSize;
            this.numPage = num < 0 ? this.total : Math.ceil(num);
            return this.numPage;
        },
        getResultPage() {
            this.currentPage = parseInt(this.currentPage);
            let start = (this.currentPage - 1) * this.pageSize;
            let end = this.currentPage * this.pageSize;
            let total = this.total;

            if (start == 0) {
                if (end > total) {
                    this.currentLengthResult = total;
                } else {
                    this.currentLengthResult = this.countInterval(start, end);
                }
            } else {
                if (end > total) {
                    this.currentLengthResult = total;
                } else {
                    this.currentLengthResult =
                        parseInt(this.currentPage) * parseInt(this.pageSize);
                }
            }

            this.$emit("update", this.currentPage, this.pageSize);
        },
        nextPage() {
            if (this.currentPage * this.pageSize < this.total)
                this.currentPage++;
            this.getResultPage();
        },
        pageCurrent(i) {
            this.currentPage = i;
        },
        prevPage() {
            if (this.currentPage > 1) this.currentPage--;
            this.getResultPage();
        },
        countInterval(a, b) {
            var count = 0;
            while (a < b) {
                a++;
                count++;
            }
            return count;
        },
    },
};
</script>
<style lang="css">
.page-item.active {
    height: 33px !important;
}
</style>
